<script setup lang="ts">
const props = defineProps<{ value: number; label: string }>()
const progress = computed(() => Math.max(0, Math.min(100, props.value || 0)))
</script>

<template>
  <div class="mm-progress" role="progressbar" :aria-label="label" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"><span :style="{ transform: `scaleX(${progress / 100})` }" /></div>
</template>

<style scoped>
.mm-progress { width: 100%; height: 8px; overflow: hidden; border-radius: var(--r-pill); background: var(--surface-3); }
.mm-progress span { display: block; width: 100%; height: 100%; background: var(--accent); transform-origin: left; transition: transform var(--d-base) var(--ease-out); }
@media (prefers-reduced-motion: reduce) { .mm-progress span { transition: none; } }
</style>
